module.exports = __webpack_public_path__ + "static/media/person_telkom.e5ceca97.png";